import { render, staticRenderFns } from "./SolanLookback.vue?vue&type=template&id=353c9952&scoped=true&"
import script from "./SolanLookback.vue?vue&type=script&lang=ts&"
export * from "./SolanLookback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c9952",
  null
  
)

export default component.exports